import { differenceInDays, isAfter, isWithinRange, startOfDay } from 'date-fns'
import { BookingCalendarList, IEvent } from '../../models/Event'

const calculateGrid = (d: Date, event: IEvent): number => {
  return differenceInDays(event.startDate, startOfDay(d))
}

export const inDateRange = (event: Date, start: Date, finish: Date) => {
  if(isAfter(start, finish)) return false
  return isWithinRange(event, start, finish)
}

export default function(
  events: IEvent[],
  startDate: Date = null,
  finishDate: Date = null,
): BookingCalendarList {
  const map: BookingCalendarList = new Map<number, IEvent>()

  for (const event of events) {
    if (
      startDate &&
      finishDate &&
      (!inDateRange(event.startDate, startDate, finishDate) &&
        !inDateRange(event.finishDate, startDate, finishDate)) &&
      (!inDateRange(startDate, event.startDate, event.finishDate) ||
        !inDateRange(finishDate, event.startDate, event.finishDate))
    ) {
      continue
    }

    const grid = calculateGrid(startDate, event)
    map.set(grid, event)
  }

  return map
}
